import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import _ from "lodash";
import Feedback from "./Feedback";
const qs = require("query-string");

class Summary extends Component {
  renderList = (onGoings, location, history) => {
    let mapping = [];
    _.uniq(onGoings.map(v => v.currentClass)).forEach(cClass => {
      // console.log(cClass);
      mapping.push({
        [cClass]: onGoings.filter(feedback => feedback.currentClass === cClass)
      });
    });

    return mapping.map((cClasses, idx) => (
      <div className="col-3 border border-dark rounded mx-3" key={idx}>
        {Object.entries(cClasses).map(([title, data], innerIdx) => (
          <div className="row" key={innerIdx}>
            <div className="col-12 border-bottom border-dark text-uppercase text-center py-2">
              {title}
            </div>
            <div className="col-12">
              {data.map((v, innerIdx2) => {
                const { length: aLength } = v.onGoing.answers || {};
                const { length: fLength } = v.onGoing.feedbacks
                  ? v.onGoing.feedbacks.filter(f => f.length)
                  : {};
                const { totalRound } = v.onGoing || {};

                return (
                  <div
                    key={innerIdx2}
                    className="d-flex justify-content-between align-items-center py-1"
                  >
                    <div>{v.name}</div>
                    <div className="text-primary">
                      {totalRound === aLength ? (
                        aLength === fLength ? (
                          <span
                            className="badge badge-dark pointer"
                            onClick={() => {
                              history.push(`${location.pathname}?uid=${v.uid}`);
                            }}
                          >
                            피드백완료
                          </span>
                        ) : (
                          <span
                            className="badge badge-info pointer"
                            onClick={() => {
                              history.push(`${location.pathname}?uid=${v.uid}`);
                            }}
                          >
                            피드백하기
                          </span>
                        )
                      ) : (
                        <span className="badge badge-light">
                          게임 진행 중..
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    ));
  };

  render() {
    const { quiz4OnGoing, location, history } = this.props;
    const params = qs.parse(location.search);
    return params.uid ? (
      <Feedback />
    ) : (
      <div className="row">
        {this.renderList(quiz4OnGoing || [], location, history)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  quiz4OnGoing: _.isEmpty(state.quiz4OnGoing) ? [] : state.quiz4OnGoing
});

export default withRouter(connect(mapStateToProps)(Summary));
